import { UFOExperience } from '@atlassian/ufo-experimental/experience';
import {
	ExperienceTypes,
	ExperiencePerformanceTypes,
} from '@atlassian/ufo-experimental/experience-types';
import { untilAll } from '@atlassian/ufo-experimental/until-helpers';

export const GlobalIssueCreateFromTopNav: UFOExperience = new UFOExperience(
	'global-issue-create-from-top-nav',
	{
		type: ExperienceTypes.Operation,
		performanceType: ExperiencePerformanceTypes.Custom,
		until: untilAll([{ category: 'global-issue-create.create-issue' }]),
	},
);
